import React, { Fragment } from 'react'
import AboutComponent from '../components/about_v2/about_us_component';
import PageHelmet from '../components/common/PageHelmet';

export default function AboutUsScreen() {
    return (
        <Fragment>
            <PageHelmet 
                title="About Us - Rubaai Digital Payment Solutions"
                description="Learn about Rubaai's mission to revolutionize digital payments. Discover our story, values, and commitment to providing secure, innovative payment solutions for the modern world."
                keywords="about Rubaai, company history, digital payment company, fintech company, payment solutions provider, Rubaai mission, company values"
            />
            <AboutComponent />
        </Fragment>
    );
}
